import React, { useState, useEffect } from 'react';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

export default function AdminAssinaturas() {
  const [assinaturas, setAssinaturas] = useState([]);
  useEffect(() => { api.get('/admin/assinaturas').then(({ data }) => setAssinaturas(data)).catch(() => {}); }, []);

  const fmtData = d => d ? new Date(d).toLocaleDateString('pt-BR') : '—';

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header"><h1 className="admin-title">Assinaturas</h1></div>
        <table className="tabela">
          <thead><tr>
            <th>Usuário</th><th>Plano</th><th>Status</th>
            <th>Trial fim</th><th>Valor</th><th>Renovação</th>
          </tr></thead>
          <tbody>
            {assinaturas.map(a => (
              <tr key={a.id}>
                <td><div style={{ fontWeight:700 }}>{a.nome}</div><div style={{ fontSize:11, color:'var(--ink-muted)' }}>{a.email}</div></td>
                <td><span className={`badge badge-${a.plano_slug||'basico'}`}>{a.plano_nome}</span></td>
                <td>
                  <span className={`badge badge-${a.status === 'trial' ? 'trial' : a.status}`}>
                    {a.status === 'trial' ? '⏳ Trial' : a.status}
                  </span>
                </td>
                <td style={{ fontSize:12, color: a.em_trial ? 'var(--rust)' : 'var(--ink-muted)' }}>
                  {a.em_trial ? fmtData(a.trial_fim) : '—'}
                </td>
                <td style={{ fontWeight:700 }}>R$ {Number(a.valor).toLocaleString('pt-BR',{minimumFractionDigits:2})}</td>
                <td style={{ fontSize:12, color:'var(--ink-muted)' }}>{fmtData(a.data_renovacao)}</td>
              </tr>
            ))}
            {assinaturas.length === 0 && <tr><td colSpan={6} style={{ textAlign:'center', color:'var(--ink-muted)', padding:32 }}>Nenhuma assinatura encontrada.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
